import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {Section} from 'constants/NavConstants';
import {getStore} from 'redux-stores/Store';
import {forceRefreshSearch} from 'search/SearchUIReduxActions';
import {postJSONPromise} from 'util/Net';

export interface CreateCanvasFolderArtifactParams {
  name: string;
  folderId: string;
  canvasVersion: string;
  description?: string;
}

export interface CreateCanvasFolderArtifactResponse {
  createdIds: Array<string>;
}

export async function createCanvasFolderArtifact(
  artifact: CreateCanvasFolderArtifactParams
): Promise<CreateCanvasFolderArtifactResponse> {
  const creates = [artifact];
  const response: CreateCanvasFolderArtifactResponse = await postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.CANVAS_FOLDER_ARTIFACT),
    data: {creates},
  });
  getStore().dispatch(forceRefreshSearch(Section.SEARCH));
  return response;
}
